import { render, staticRenderFns } from "./BottomToolbar.vue?vue&type=template&id=f4b6acba&scoped=true&"
import script from "./BottomToolbar.vue?vue&type=script&lang=js&"
export * from "./BottomToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BottomToolbar.vue?vue&type=style&index=0&id=f4b6acba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b6acba",
  null
  
)

export default component.exports